import { __awaiter } from "tslib";
import CpuAction from "../CpuAction";
import { parseBinary } from "../../../../util/instructionParser";
export default class SetIR extends CpuAction {
    constructor() {
        super();
        this._name = "SetIR";
    }
    action(ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            ctx.cpu.model.instructionRegister.set(parseBinary(ctx.wires.model.data_main.get().toBinaryString()));
            yield ctx.cpu.component.flash("IR");
        });
    }
}
